import React from 'react';
import { Typography } from '@mui/material';
import { googlePlay, courseExpert, bestChange, exnode } from '../assets/images';
import { Phone, Vk, ChatButton } from "../assets/images/icons";
import { Link } from 'react-router-dom'
import { getText, useClipboard } from '../libs/utils';
import { JivoChatTrigger } from '../JivoChat';

export default function Footer() {
  const copyToClipboard = useClipboard();

  return (
    <footer>
      <div className="col-1">
        <Typography fontSize={10} fontWeight={600} gutterBottom>
          {getText('footerPrimaryInfo1')} <br />
          © {getText('footerAllRights')} {new Date().getFullYear()}
        </Typography>
        <Link to="/rules"><Typography fontSize={12} fontWeight={700} display="inline-block" gutterBottom>{getText('linkRules')}</Typography></Link>
      </div>
      <div className="col-2">
        {/*<span className="title">{getText('footerSocials')}:</span>*/}
        <div className="icons">
          {/*<a href="viber://pa?chatURI=crypsternet" target="_blank" rel="noreferrer"><Phone /></a>*/}
        </div>
      </div>
      <div className="col-3">
        <span className="title">{getText('footerContacts')}:</span>
        <Typography fontSize={12} fontWeight={500} display="block" gutterBottom sx={{ cursor: 'pointer' }} onClick={copyToClipboard}>support@crypster.net</Typography>
        <Typography fontSize={12} fontWeight={500} display="block" gutterBottom sx={{ cursor: 'pointer' }} onClick={copyToClipboard}>partner@crypster.net</Typography>
      </div>

      <div className="col-5">
        <a href={getText("bestLink")} target="_blank" rel="noreferrer"><img src={bestChange} alt="" /></a>
        {/*<a href="https://exnode.ru/" target="_blank" rel="noreferrer"><img src={exnode} alt="" /></a>*/}
        {/*<a href="https://kurs.expert/ru/obmennik/crypster-net/" target="_blank" rel="noreferrer"><img src={courseExpert} alt="" /></a>*/}
      </div>
      <JivoChatTrigger component="span" hideWhenOpen id="jivo_custom_widget" style={{ position: 'fixed', right: '32px', bottom: '32px', cursor: 'pointer', width: '64px', height: '64px' }}>
        <ChatButton style={{ width: '100%', height: '100%' }} />
      </JivoChatTrigger>
    </footer>
  )
}
